module.exports = __webpack_public_path__ + "img/rotate-left.2f5cd97b.svg";